export const profileRolesConstants = {
  FETCH_PROFILE_ROLES_REQUEST: 'FETCH_PROFILE_ROLES_REQUEST',
  FETCH_PROFILE_ROLES_SUCCESS: 'FETCH_PROFILE_ROLES_SUCCESS',
  FETCH_PROFILE_ROLES_ERROR: 'FETCH_PROFILE_ROLES_ERROR'
}
